import { Loader } from 'ui/services';
import CONFIG from 'ui/config';

export const handleCashfree = async (shop, data) => {
  const options = {
    appId: data.appId,
    orderId: data.orderId,
    orderAmount: data.orderAmount?.toString(),
    orderCurrency: data.orderCurrency,
    customerName: data?.name,
    customerEmail: data?.email,
    customerPhone: data.phone.replace(/^\+91\s*/, ''),
    returnUrl: data.returnUrl,
    signature: data.tokenData,
  };

  if (data.notifyUrl) {
    options.notifyUrl = data.notifyUrl;
  }

  if (data.vendorSplit) {
    options.vendorSplit = data.vendorSplit;
  }

  if (data.paymentModes) {
    options.paymentModes = data.paymentModes;
  }

  Loader.show();
  const ele = document.createElement('form');

  ele.setAttribute('method', 'POST');
  ele.setAttribute('action', CONFIG.CASHFREE.host);
  ele.style.display = 'none';

  Object.entries(options)
    .forEach(([key, value]) => {
      const inp = document.createElement('input');
      inp.setAttribute('type', 'hidden');
      inp.setAttribute('name', key);
      inp.setAttribute('value', value);
      ele.appendChild(inp);
    });

  document.body.appendChild(ele);
  ele.submit();
};
